import clsx from 'clsx'
import Link from 'next/link'

export default function Button({
  as = 'button',
  className = '',
  variant = 'primary',
  width = 'auto',
  ...props
}: {
  as?: React.ElementType
  className?: string
  variant?: 'primary' | 'secondary' | 'inline'
  width?: 'auto' | 'full'
  [key: string]: any
}) {
  const Component = props?.to ? Link : as

  const baseButtonClasses =
    'inline-block rounded font-medium text-center py-3 px-6'

  const variants = {
    primary: `${baseButtonClasses} bg-primary text-contrast`,
    secondary: `${baseButtonClasses} border border-primary/10 bg-white text-primary`,
    inline: 'border-b border-primary/10 leading-none pb-1',
  }

  const widths = {
    auto: 'w-auto',
    full: 'w-full',
  }

  const styles = clsx(
    missingClass(className, 'bg-') && variants[variant],
    missingClass(className, 'w-') && widths[width],
    className && widths[width],
    props.disabled ? 'opacity-50 cursor-not-allowed bg-gray-500' : '',
  )

  return <Component className={styles} {...props} />
}

export function missingClass(string?: string, prefix?: string) {
  if (!string) {
    return true
  }

  const regex = new RegExp(` ?${prefix}`, 'g')
  return string.match(regex) === null
}
